import React from 'react';
import Slider from 'react-slick';
import {
    Box,
    Typography,
    Card,
    CardMedia,
    CardContent,
    Button,
    Grid,
} from '@mui/material';
import PackageCard from './PackageCard';
import packageData from '../data/packages.json';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/carousel.css';
import DomesticPackage from '../data/domesticPackage.json'
import InternationPackages from '../data/internationPackages.json';    

import { ArrowBackIos, ArrowForwardIos, Padding } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const CustomPrevArrow = ({ className, style, onClick }) => (
    <IconButton
        onClick={onClick}
        className={className}
        sx={{
            ...style,
            position: 'absolute',
            left: 20,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
            color: '#fff !important',
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: '#0e8279 !important'
        }}
    >
        <ArrowBackIos fontSize="small" />
    </IconButton>
);



const CustomNextArrow = ({ className, style, onClick }) => (
    <IconButton
        onClick={onClick}
        className={className}
        sx={{
            ...style,
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
            color: '#fff !important',
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: '#0e8279 !important'
        }}
    >
        <ArrowForwardIos fontSize="small" />
    </IconButton>
);


console.log('packageData-->', packageData)

const PackageCarousel = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        arrows: true,
        nextArrow: <CustomNextArrow />,   // 👈 Use custom arrows
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: true  // ✅ keep this true
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 2700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
        ],
    };


    return (
        <Box sx={{ px: 2, py: 4}}>
            <Box sx={{ mb: 6 }}>
                <Typography variant="h5" sx={{ pl: 4, fontWeight: "bold", fontSize: "1.5rem" }}>
                    Popular Packages
                </Typography>
                <Typography sx={{ pl: 4 }}>
                    When we say tour package, it means a pre-arrangement, prepaid trip that combines two or more travel components like airfare, airport transfer, accommodation, and other services. Here we providing you a complete range of various tour packages.
                </Typography>
                <Slider {...settings}>
                    {packageData.map((pkg) => (
                        <Box key={pkg.id} sx={{ p: 1 }}>
                            <PackageCard
                                name={pkg.name}
                                image={pkg.image}
                                duration={pkg.duration}
                                price={pkg.price}
                                destinationId={pkg.destinationId} // ✅ assuming this exists in packageData
                                packageId={pkg.id.toString()}
                                packageType={'packages'}
                            />
                        </Box>
                    ))}
                </Slider>
            </Box>

            <Box sx={{ my: 4 }} />
            <Box sx={{ mb: 6 }}>
                <Typography variant='h5' sx={{ pl: 4, fontWeight: "bold", fontSize: "1.5rem" }}>
                    TRENDING DOMESTIC DESTINATION
                </Typography>
                <Slider {...settings}>
                    {DomesticPackage.map((pkg) => (
                        <Box key={pkg._id} sx={{ p: 1 }}>
                            <PackageCard
                                name={pkg.name}
                                image={pkg.images}
                                duration={pkg.duration}
                                price={pkg.price}
                                destinationId={pkg.destinationslug} // ✅ assuming this exists in packageData
                                packageId={pkg._id.toString()}
                                packageType={'domestictrips'}
                            ></PackageCard>
                        </Box>
                    ))

                    }
                </Slider>
            </Box>

            <Box sx={{ my: 4 }} />
            <Box sx={{ mb: 6 }}>
                <Typography variant='h5' sx={{ pl: 4, fontWeight: "bold", fontSize: "1.5rem" }}>
                    TRENDING INTERNATIONAL DESTINATION
                </Typography>
                <Slider {...settings}>
                    {InternationPackages.map((pkg) => (
                        <Box key={pkg._id} sx={{ p: 1 }}>
                            <PackageCard
                                name={pkg.name}
                                image={pkg.images}
                                duration={pkg.duration}
                                price={pkg.price}
                                destinationId={pkg.destinationslug} // ✅ assuming this exists in packageData
                                packageId={pkg._id.toString()}
                                packageType={'internationaltrips'}
                            ></PackageCard>
                        </Box>
                    ))

                    }
                </Slider>
            </Box>
        </Box>
    );
}

export default PackageCarousel;
